import { SelectOption } from 'components/new-ui/composed/formSelect/FormSelect';
import { JobResponse } from 'store/jobs/job';
import { Manifest } from 'store/manifests/types';

export type ExternalReferencesModalType = 'manifest' | 'job' | 'manifestJob';

export type ExternalReference = {
    referenceType: string;
    referenceNumber: string;
};

export enum ReferenceTypes {
    ENS = 'ens',
    MANIFEST_ENS_REFERENCE = 'ensReference',
    PBN = 'pbn',
    GMR = 'gmr',
    UK_CDS_MRN = 'cdsExportMRN',
}

export const referenceTypeOptionsMap: Record<ExternalReferencesModalType, SelectOption[]> = {
    manifest: [
        { id: ReferenceTypes.PBN, value: 'PBN' },
        { id: ReferenceTypes.GMR, value: 'GMR' },
        { id: ReferenceTypes.MANIFEST_ENS_REFERENCE, value: 'ENS' },
    ],
    job: [
        { id: ReferenceTypes.ENS, value: 'ENS' },
        { id: ReferenceTypes.PBN, value: 'PBN' },
        { id: ReferenceTypes.GMR, value: 'GMR' },
        { id: ReferenceTypes.UK_CDS_MRN, value: 'UK Export MRN' },
    ],
    manifestJob: [{ id: ReferenceTypes.UK_CDS_MRN, value: 'UK Export MRN' }],
};

export const getManifestExternalReferences = (manifest: Manifest): ExternalReference[] => {
    const result: ExternalReference[] = [];

    const { ensReference, pbn, gmr, cdsExportMRN } = manifest;

    if (ensReference) {
        result.push({
            referenceType: ReferenceTypes.MANIFEST_ENS_REFERENCE,
            referenceNumber: ensReference,
        });
    }

    if (pbn) {
        result.push({
            referenceType: ReferenceTypes.PBN,
            referenceNumber: pbn,
        });
    }

    if (gmr) {
        result.push({
            referenceType: ReferenceTypes.GMR,
            referenceNumber: gmr,
        });
    }

    if (cdsExportMRN) {
        result.push({
            referenceType: ReferenceTypes.UK_CDS_MRN,
            referenceNumber: cdsExportMRN,
        });
    }

    return result;
};

export const getExternalReferencesFromJob = (job: JobResponse): ExternalReference[] => {
    const result: ExternalReference[] = [];

    if (job.externalReferences?.cdsExportMRN) {
        result.push({
            referenceType: ReferenceTypes.UK_CDS_MRN,
            referenceNumber: job.externalReferences.cdsExportMRN,
        });
    }

    if (job.externalReferences?.ens) {
        result.push({
            referenceType: ReferenceTypes.ENS,
            referenceNumber: job.externalReferences.ens,
        });
    }

    if (job.externalReferences?.gmr) {
        result.push({
            referenceType: ReferenceTypes.GMR,
            referenceNumber: job.externalReferences.gmr,
        });
    }

    if (job.externalReferences?.pbn) {
        result.push({
            referenceType: ReferenceTypes.PBN,
            referenceNumber: job.externalReferences.pbn,
        });
    }

    return result;
};

export const getExternalReferenceFromManifestJob = (job: JobResponse): ExternalReference[] => {
    const result: ExternalReference[] = [];

    if (job?.externalReferences?.cdsExportMRN) {
        result.push({
            referenceType: ReferenceTypes.UK_CDS_MRN,
            referenceNumber: job.externalReferences.cdsExportMRN,
        });
    }

    return result;
};
